export function cssGradient(colors) {
  let dx = 1 / (colors.length - 1)
  let parts = colors.map((c, i) => {
    return `${c} ${100 * i * dx}%`
  })
  return 'linear-gradient(90deg, ' + parts + ')'
}

export const MAP_COLORS = {
  blue: ['#BBD6E8', '#15537E'],
  yellow: ['#FFECB5', '#B28707'],
  green: ['#D7E2D8', '#566F57'],
  orange: ['#F7CFB2', '#A14300'],
  purple: ['#E7DEF0', '#7B6590'],
  posneg: ['#ED1C24', '#60B760'],
  multi: ['#ED1C24', '#FFFF00', '#60B760'],
}

import { range as d3_range, extent as d3_extent } from 'd3-array'
import ckmeans from 'ckmeans'
import {
  scaleLinear as d3_scaleLinear,
  scaleQuantize as d3_scaleQuantize,
  scaleQuantile as d3_scaleQuantile,
  scaleThreshold as d3_scaleThreshold,
} from 'd3-scale'

export function colorScaleFromConfig(colorConfig, values) {
  let scale, domain, range
  let extent = d3_extent(values)

  if (colorConfig.scaleOption === 'gradient') {
    scale = d3_scaleLinear()
    // domain = [extent[0], extent[1]]
    domain = d3_range(
      extent[0],
      extent[1],
      (extent[1] - extent[0]) / (colorConfig.colorRange.length - 1)
    ).concat(extent[1])
    range = colorConfig.colorRange
    scale.domain(domain).range(range)
  } else {
    let linearScale = d3_scaleLinear()
      .domain(d3_range(0, 1.001, 1 / (colorConfig.colorRange.length - 1)))
      .range(colorConfig.colorRange)
    if (colorConfig.interpolationType === 'rounded') {
      scale = d3_scaleQuantize()
      domain = [extent[0], extent[1]]
      //se podria probar con d3_ticks pero daba algun problema...
      range = d3_range(0, 1.001, 1 / (colorConfig.scaleSteps - 1)).map(t => linearScale(t))
      scale.domain(domain).range(range).nice()
    } else if (colorConfig.interpolationType === 'quantiles') {
      scale = d3_scaleQuantile()
      domain = values
      range = d3_range(0, 1.001, 1 / (colorConfig.scaleSteps - 1)).map(t => linearScale(t))
      scale.domain(domain).range(range)
    } else if (colorConfig.interpolationType === 'jenks') {
      scale = d3_scaleQuantile()
      domain = ckmeans(values, colorConfig.scaleSteps - 1)
      range = d3_range(0, 1.001, 1 / (colorConfig.scaleSteps - 1)).map(t => linearScale(t))
      scale.domain(domain).range(range)
    } else if (colorConfig.interpolationType === 'custom') {
      scale = d3_scaleThreshold()
      domain = colorConfig.customSteps.slice(0, -1).map(s => s.max)
      range = d3_range(0, 1.001, 1 / (colorConfig.scaleSteps - 1)).map(t => linearScale(t))
      scale.domain(domain).range(range)
    } else {
      //linear
      scale = d3_scaleQuantize()
      domain = [extent[0], extent[1]]
      range = d3_range(0, 1.001, 1 / (colorConfig.scaleSteps - 1)).map(t => linearScale(t))
      scale.domain(domain).range(range)
    }
  }

  return scale
}

export const bcnColors = [
  '#4B92C3',
  '#FFCE3A',
  '#96B297',
  '#EB8032',
  '#C0A6D8',
  '#7FC57F',
  '#41B6C4',
  '#FE5BAC',
  '#BBBB47',
  '#F0494F',
  '#CBCBCB',
  '#B38557',
]
